import { render, staticRenderFns } from "./ClrmToolbarSecondary.vue?vue&type=template&id=23a66957&"
import script from "./ClrmToolbarSecondary.vue?vue&type=script&lang=js&"
export * from "./ClrmToolbarSecondary.vue?vue&type=script&lang=js&"
import style0 from "./ClrmToolbarSecondary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports